import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

const TrackCount = ({ trackCount }) => (
  <FormattedMessage
    id="personal-playlists.track-count"
    defaultMessage="{trackCount, plural, one {# Track} other {# Tracks}}"
    values={{
      trackCount,
    }}
  />
);

TrackCount.propTypes = {
  trackCount: PropTypes.number.isRequired,
};

export default TrackCount;
